import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#FDA7A6", // Main brand color
    },
    secondary: {
      main: "#FDA7A6", // Accent color
    },
    error: {
      main: "#f44336",
    },
    warning: {
      main: "#ff9800",
    },
    info: {
      main: "#FDA7A6",
    },
    success: {
      main: "#4caf50",
    },
  },
});

export default theme;
